import { useEffect, useRef } from 'react';

import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const ActionWrapper = ({ title, onClose, children }) => {
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      contentRef.current.scrollTop = contentRef.current.scrollHeight;
    }
  }, [children]);

  return (
    <div className="border-l-solid right-14 top-0 z-10 flex h-full w-full min-w-[340px] max-w-[512px] flex-1 flex-col items-center gap-4 border-l border-l-neutral-100 bg-white shadow-[-2px_0px_4px_rgba(42,92,138,0.1)] sm:absolute sm:min-w-[320px] sm:max-w-[320px] md:absolute md:min-w-[400px] md:max-w-[400px]">
      <div className="flex w-full items-center justify-between gap-[180px] border-b border-solid border-white border-b-neutral-100 bg-white px-4 py-3">
        <Typography color="neutral-800" size="large" weight="600">
          {title}
        </Typography>
        <Icon
          icon="new-close"
          className="cursor-pointer"
          color="neutral"
          shade="700"
          size={12}
          onClick={onClose}
        />
      </div>
      <div ref={contentRef} className="flex w-full flex-1 flex-col overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export default ActionWrapper;
